<nav class="navbar navbar-light">
  <div class="w-100 d-flex justify-content-between text-center align-items-center position-relative">
    <!-- Back Button -->
    <div (click)="backClicked.emit()" style="z-index: 2;">
      <!-- <i class="fa-solid fa-reply"></i> -->
      <i class="fa-solid fa-chevron-left"></i>
    </div>

    <!-- Logo Container -->
    <div class="logo-container position-absolute d-flex justify-content-center w-100" style="z-index: 1;">
      <img src="assets/icons/mobile/Scout_Mobile_Icon_BlueWhite.svg" alt="Logo" style="height: 40px;" />
    </div>
  </div>
</nav>


      <!-- Conditional rendering of the home button -->
      <!-- <button *ngIf="homeButtonText" class="btn btn-outline-primary" (click)="homeClicked ? homeClicked.emit() : null">
        <i *ngIf="icon" [class]="icon"></i> {{ homeButtonText }}
      </button> -->
    <!-- </div>
  </nav> -->
  
